import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setProductJson } from '../../redux/Actions/BillingAction'
import { Minus, Package, Plus, Trash2 } from 'lucide-react'
import MySearchableSelect from '../../components/MyComponent/BillingSearchableSelect'
import { searchProduct, searchStaff, searchUser } from '../../constant/Constant'
import MyInput from '../../components/MyComponent/MyInput'
import { calculateBillSummary } from '../../utils/utils'
import { SET_BILLING_PRODUCTS_DATA } from '../../redux/ActionName/ActionName'
import { setDataAction } from '../../redux/Actions/SetDataAction'

export const ProductSection = () => {
    const BillingReducer = useSelector((state) => state.BillingReducer)
    const dispatch = useDispatch()
    const handelServiceChange = (type, value, index) => {
        let oldData = [...BillingReducer?.selectedProducts];

        if (type === 'removeProduct') {
            oldData = [...oldData.slice(0, index), ...oldData.slice(index + 1)]
        }
        else {
            if (type === "selectProduct") {
                const quantity = oldData[index]?.quantity || 1;
                oldData[index] = { ...oldData[index], product: value, price: value.sellPrice, total: value.sellPrice * quantity, };
            }
            else if (type === 'changeQty') {
                oldData[index] = { ...oldData[index], quantity: value }
            }
            else if (type === 'selectStaff') {
                oldData[index] = { ...oldData[index], staffData: value };
            }
            else if (type === 'changePrice') {
                if (value !== '' && !/^(?:[0-9]+(?:\.[0-9]*)?)?$/.test(value)) return;
                oldData[index] = { ...oldData[index], price: value }
            }
            const price = oldData[index].price
            const qty = oldData[index].quantity || 1;
            oldData[index] = { ...oldData[index], total: price * qty }
        }
        dispatch(setDataAction(oldData, SET_BILLING_PRODUCTS_DATA));
        const updatedBillingReducer = { ...BillingReducer, selectedProducts: oldData };
        calculateBillSummary(updatedBillingReducer, dispatch);
    };
    return (
        <div>  {(BillingReducer?.selectedProducts || []).length > 0 && (
            <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex items-center gap-2 mb-4">
                    <Package className="text-blue-600" size={20} />
                    <h2 className="text-xl font-semibold text-gray-800">Select Products</h2>
                </div>
                {(BillingReducer?.selectedProducts).map((product, index) => (
                    <div key={product.id} className="grid grid-cols-5 gap-4 mb-4 items-end">
                        <div>
                            <MySearchableSelect giveFullElement={true} api={searchProduct} value={product?.product?.productName} optionLable="productName" onChange={(value) => handelServiceChange("selectProduct", value, index)} title="Search Product" placeholder={"Select Product"} />
                        </div>
                        <div>
                            <MySearchableSelect giveFullElement={true} api={searchUser} value={product?.staffData?.name} optionLable="name" onChange={(value) => handelServiceChange("selectStaff", value, index)} title="Search Staff" placeholder={"Select Staff"} />
                        </div>
                        <div>
                            <MyInput onChange={(e) => handelServiceChange('changePrice', e.target.value, index)} title={'Price'} value={product?.price || ""} />
                        </div>
                        <div>
                            <div className="flex items-center">
                                <button
                                    type="button"
                                    onClick={() => handelServiceChange('changeQty', BillingReducer?.selectedProducts[index]?.quantity === 1 ? 1 : BillingReducer?.selectedProducts[index]?.quantity - 1, index)}
                                    className="p-2 bg-gray-200 mt-8  rounded-l-lg hover:bg-gray-300"
                                >
                                    <Minus size={16} />
                                </button>
                                <MyInput title={"quantity"} value={product.quantity} onClick={(e) => handelServiceChange('changeQty', e.target.value, index)} />
                                <button
                                    type="button"
                                    onClick={() => handelServiceChange('changeQty', BillingReducer?.selectedProducts[index]?.quantity + 1, index)}
                                    className="p-2 bg-gray-200 mt-8 rounded-r-lg hover:bg-gray-300"
                                >
                                    <Plus size={16} />
                                </button>
                            </div>
                        </div>
                        <div className="flex items-center gap-2">
                            <span className="text-lg font-semibold text-gray-800">₹{product.total}</span>
                            <button
                                onClick={() => handelServiceChange("removeProduct", false, index)}
                                className="text-red-500 hover:text-red-700"
                            >
                                <Trash2 size={16} />
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        )}</div>
    )
}
